import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
const perks = ['6 módulos de puro conocimiento para transformar tu cuerpo', 'Plan de Caminatas según tu Nivel para avanzar a tu ritmo', 'Checklist de Hábitos que potencian tu progreso', 'Guía de Errores Frecuentes y Cómo Corregirlos'];
export function FinalCta() {
  return <section className="w-full bg-cream" data-id="element-61" data-mp="1jcd76hp3ycfp">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-24" data-id="element-62" data-mp="1jbaj0hj66o3h">
        <Reveal data-id="element-63" data-mp="1ed8wtnqg68ns">
          <h2 className="font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-64" data-mp="1eds5edu7jkp5">
            Cada paso que dás te acerca a tu mejor versión
          </h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-65" data-mp="1o4wjlbc271ix">
            Dejá de buscar la solución complicada. La más simple y poderosa ya la tenés en tus pies.
          </p>

          <ul className="mx-auto mt-8 max-w-md space-y-3 text-left" data-id="element-66" data-mp="1x4jjfsp53z9v">
            {perks.map(p => <li key={p} className="flex items-start gap-3 text-sm text-ink/80" data-id="element-67" data-mp="n5ul3zmwvjfp">
                <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand" data-id="element-68" data-mp="n7yugx3kxand" />
                {p}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-69" data-mp="x2qsu34zk1j7">
            <CtaButton trackingEvent="Lead" data-id="element-70" data-mp="x5v5zq0fi7m0">VER OFERTA Y PRECIO</CtaButton>
          </div>
          <p className="mt-5 text-sm font-medium text-ink/60" data-id="element-71" data-mp="1246g81umyk4r">
            🔒 $22.990 · Pago con Mercado Pago · Devolución de 7 días
          </p>
        </Reveal>
      </div>
    </section>;
}